module.exports = __webpack_public_path__ + "static/media/tertiary-staff.95dd46ae.svg";